/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultTagsState = null

/**
 * Export
 */
export const tags = handleActions({
  GET_TAGS: (state, action) => {
    return action.payload
  },
}, defaultTagsState)

export const selectedTag = handleActions({
  SELECT_TAG: (state, action) => {
    return action.payload
  },
}, defaultTagsState)

export default {
  tags,
  selectedTag,
}



// WEBPACK FOOTER //
// ./src/reducers/components/tag.js